import React from "react";
import { NavLink } from "react-router-dom";

interface SidebarItemProps {
  to: string;
  exact?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  hover?: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  to,
  exact = false,
  onClick,
  children,
  hover,
}) => {
  return (
    <NavLink
      to={to}
      end={exact}
      onClick={onClick}
      className={({ isActive }) =>
        `su-menu-link no-underline ${hover ? "" : ""} ` +
        (isActive ? "su-menu-link-active" : "")
      }
    >
      {children}
    </NavLink>
  );
};

export default SidebarItem;
